// src/components/inbox/InboxThreadDialog.tsx

'use client'

import { X } from 'lucide-react'

import { InboxChat } from '@/components/inbox/InboxChat'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog'

export function InboxThreadDialog({
  conversationId,
  open,
  onOpenChange,
}: {
  conversationId: number | null
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        className="
          flex
          h-[min(760px,88vh)]
          w-[min(920px,94vw)]
          max-w-none
          flex-col
          overflow-hidden
          rounded-3xl
          border
          bg-background
          p-0
          shadow-2xl
          [&>button]:hidden
        "
      >
        <DialogTitle className="sr-only">
          Conversación
        </DialogTitle>

        {conversationId ? (
          <div className="relative h-full min-h-0">
            <InboxChat
              initialConversationId={conversationId}
              mode="thread"
            />

            <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={() => onOpenChange(false)}
            className="
                absolute
                right-4
                top-[18px]
                z-40
                h-9
                w-9
                rounded-full
                bg-background/90
                shadow-sm
                backdrop-blur
                hover:bg-muted
            "
            aria-label="Cerrar conversación"
            >
            <X className="h-4 w-4" />
            </Button>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  )
}